import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import CustomCheckoutSignupStepper from "./CheckoutSignupStepper";

const CheckoutSignupPage7: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();
  const location = useLocation();

  const safeNavigate = (path: string) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  useEffect(() => {
    const step3Completed = localStorage.getItem("step-3-completed");
    if (step3Completed) {
      safeNavigate("/glp1/getting-started/step-4");
    } else {
      safeNavigate("/glp1/getting-started/step-3");
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
  };

  const handleNext = () => {
    if (selectedOption) {
      localStorage.setItem(
        "previous_medication_duration",
        JSON.stringify({
          key: "previous_medication_duration",
          value: selectedOption,
          id: 18026060,
        })
      );
    }
    localStorage.setItem("step-4-completed", "true");
  };

  useEffect(() => {
    const savedPreviousMedicationDuration = localStorage.getItem(
      "previous_medication_duration"
    );

    if (savedPreviousMedicationDuration) {
      const parsedPreviousMedicationDuration = JSON.parse(
        savedPreviousMedicationDuration
      );
      setSelectedOption(parsedPreviousMedicationDuration.value);
    }
  }, []);

  const options = [
    "I’ve never tried dieting or exercise",
    "Less than 6 months",
    "6-12 months",
    "Several years",
    "My whole life",
  ];
  const handleBack = () => {
    safeNavigate("/glp1/getting-started/step-3");
  };

  return (
    <PageWrapper onBack={handleBack}>
      <div className="signup-page-container container">
        <CustomCheckoutSignupStepper activeStep={1} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-content-header">
            How long have you been trying to lose weight?
          </p>
          <div className="options options-box-contents">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          <button
            className="next-btn sticky-btn"
            onClick={() => {
              handleNext();
              safeNavigate("/glp1/getting-started/step-5");
            }}
            disabled={!selectedOption}
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default CheckoutSignupPage7;
